import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRootRoutingModule } from './app-root-routing.module';
import { AppRootComponent } from './app-root.component';
import { GraphQLModule } from './graphql.module';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { OAuthModule } from 'angular-oauth2-oidc';
import { LibAuthModule } from 'lib-auth';
import { LibComponentsModule } from 'lib-components';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import customParseFormat from 'dayjs/plugin/customParseFormat';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, '/api/public/i18n/messages', '.json');
}

dayjs.extend(customParseFormat);
dayjs.extend(isoWeek);

@NgModule({ declarations: [
        AppRootComponent
    ],
    bootstrap: [AppRootComponent], imports: [BrowserModule,
        AppRootRoutingModule,
        GraphQLModule,
        OAuthModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        LibAuthModule,
        LibComponentsModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class AppRootModule {
}
